import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" };
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-12" };
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between mb-20" };
const _hoisted_6 = { class: "text-black fw-semibold mb-0" };
const _hoisted_7 = { class: "text-muted mb-0" };
const _hoisted_8 = { class: "position-relative" };
const _hoisted_9 = {
    key: 0,
    class: "col-md-12"
};
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_11 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_12 = { class: "col-md-6" };
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_15 = ["placeholder"];
const _hoisted_16 = { class: "text-muted" };
const _hoisted_17 = { class: "col-md-6" };
const _hoisted_18 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_19 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_20 = ["placeholder"];
const _hoisted_21 = { class: "text-muted" };
const _hoisted_22 = { class: "col-md-6" };
const _hoisted_23 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_24 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_25 = ["placeholder"];
const _hoisted_26 = { class: "text-muted" };
const _hoisted_27 = { class: "col-md-6" };
const _hoisted_28 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_29 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_30 = ["placeholder"];
const _hoisted_31 = { class: "text-muted" };
const _hoisted_32 = { class: "col-md-6" };
const _hoisted_33 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_34 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_35 = { class: "text-muted" };
const _hoisted_36 = { class: "col-md-6" };
const _hoisted_37 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_38 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_39 = { class: "text-muted" };
const _hoisted_40 = { class: "col-md-12" };
const _hoisted_41 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_42 = { class: "form-check form-switch" };
const _hoisted_43 = {
    class: "form-check-label text-black fw-semibold",
    for: "isActiveSwitch"
};
const _hoisted_44 = { class: "col-md-12" };
const _hoisted_45 = {
    class: "alert alert-info",
    role: "alert"
};
const _hoisted_46 = { class: "col-md-12" };
const _hoisted_47 = {
    key: 0,
    class: "d-flex align-items-center justify-content-between"
};
const _hoisted_48 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_select = _resolveComponent("v-select");
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("form", {
                onSubmit: _cache[9] || (_cache[9] = _withModifiers(
                //@ts-ignore
                (...args) => (_ctx.saveTimeSlot && _ctx.saveTimeSlot(...args)), ["prevent"]))
            }, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.actionDetected === "edit"
                                    ? _ctx.$t('forms.editTimeSlot')
                                    : _ctx.$t('forms.addTimeSlot')), 1),
                                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('forms.configureDelays')), 1)
                            ]),
                            _createElementVNode("button", {
                                type: "button",
                                onClick: _cache[0] || (_cache[0] =
                                    //@ts-ignore
                                    (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                            }, [
                                _cache[10] || (_cache[10] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('common.cancel')), 1)
                            ])
                        ])
                    ]),
                    (_ctx.userRole === _ctx.UserRole.FRANCHISE)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('lists.restaurant')) + " * ", 1),
                                _createVNode(_component_v_select, {
                                    modelValue: _ctx.selectedRestaurant,
                                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.selectedRestaurant) = $event)),
                                    options: _ctx.restaurantOptions,
                                    label: "name",
                                    reduce: (restaurant) => restaurant.id,
                                    placeholder: _ctx.$t('lists.selectRestaurant'),
                                    class: "restaurant-select",
                                    onInput: _ctx.onRestaurantChange,
                                    required: ""
                                }, null, 8, ["modelValue", "options", "reduce", "placeholder", "onInput"])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('forms.pickupDelay')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                        'is-invalid': !_ctx.timeSlotData.pickupDelayMinutes ||
                                            _ctx.timeSlotData.pickupDelayMinutes < 1,
                                    }]),
                                placeholder: _ctx.$t('forms.pickupDelayPlaceholder'),
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.timeSlotData.pickupDelayMinutes) = $event)),
                                min: "1",
                                required: ""
                            }, null, 10, _hoisted_15), [
                                [
                                    _vModelText,
                                    _ctx.timeSlotData.pickupDelayMinutes,
                                    void 0,
                                    { number: true }
                                ]
                            ]),
                            _createElementVNode("small", _hoisted_16, _toDisplayString(_ctx.$t('forms.pickupDelayHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t('forms.deliveryDelay')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                        'is-invalid': !_ctx.timeSlotData.deliveryDelayMinutes ||
                                            _ctx.timeSlotData.deliveryDelayMinutes < 1,
                                    }]),
                                placeholder: _ctx.$t('forms.deliveryDelayPlaceholder'),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.timeSlotData.deliveryDelayMinutes) = $event)),
                                min: "1",
                                required: ""
                            }, null, 10, _hoisted_20), [
                                [
                                    _vModelText,
                                    _ctx.timeSlotData.deliveryDelayMinutes,
                                    void 0,
                                    { number: true }
                                ]
                            ]),
                            _createElementVNode("small", _hoisted_21, _toDisplayString(_ctx.$t('forms.deliveryDelayHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('forms.slotInterval')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                        'is-invalid': !_ctx.timeSlotData.slotIntervalMinutes ||
                                            _ctx.timeSlotData.slotIntervalMinutes < 1,
                                    }]),
                                placeholder: _ctx.$t('forms.slotIntervalPlaceholder'),
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.timeSlotData.slotIntervalMinutes) = $event)),
                                min: "1",
                                required: ""
                            }, null, 10, _hoisted_25), [
                                [
                                    _vModelText,
                                    _ctx.timeSlotData.slotIntervalMinutes,
                                    void 0,
                                    { number: true }
                                ]
                            ]),
                            _createElementVNode("small", _hoisted_26, _toDisplayString(_ctx.$t('forms.slotIntervalHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t('forms.maxCapacity')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                        'is-invalid': !_ctx.timeSlotData.maxCapacity || _ctx.timeSlotData.maxCapacity < 1,
                                    }]),
                                placeholder: _ctx.$t('forms.maxCapacityPlaceholder'),
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.timeSlotData.maxCapacity) = $event)),
                                min: "1",
                                required: ""
                            }, null, 10, _hoisted_30), [
                                [
                                    _vModelText,
                                    _ctx.timeSlotData.maxCapacity,
                                    void 0,
                                    { number: true }
                                ]
                            ]),
                            _createElementVNode("small", _hoisted_31, _toDisplayString(_ctx.$t('forms.maxCapacityHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t('forms.startTime')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "time",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                        'is-invalid': !_ctx.timeSlotData.startTime,
                                    }]),
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.timeSlotData.startTime) = $event)),
                                required: ""
                            }, null, 2), [
                                [_vModelText, _ctx.timeSlotData.startTime]
                            ]),
                            _createElementVNode("small", _hoisted_35, _toDisplayString(_ctx.$t('forms.startTimeHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                        _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('forms.endTime')) + " * ", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "time",
                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                        'is-invalid': !_ctx.timeSlotData.endTime,
                                    }]),
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.timeSlotData.endTime) = $event)),
                                required: ""
                            }, null, 2), [
                                [_vModelText, _ctx.timeSlotData.endTime]
                            ]),
                            _createElementVNode("small", _hoisted_39, _toDisplayString(_ctx.$t('forms.endTimeHelp')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_40, [
                        _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("div", _hoisted_42, [
                                _withDirectives(_createElementVNode("input", {
                                    class: "form-check-input",
                                    type: "checkbox",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.timeSlotData.isActive) = $event)),
                                    id: "isActiveSwitch"
                                }, null, 512), [
                                    [_vModelCheckbox, _ctx.timeSlotData.isActive]
                                ]),
                                _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('forms.activateConfig')), 1)
                            ])
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "fas fa-info-circle me-2" }, null, -1)),
                            _createElementVNode("strong", null, _toDisplayString(_ctx.$t('forms.example')) + " :", 1),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('forms.timeSlotExample')), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_46, [
                        (_ctx.actionDetected)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                        type: "submit",
                                        disabled: !_ctx.isFormValid
                                    }, _toDisplayString(_ctx.actionDetected === "edit"
                                        ? _ctx.$t('forms.updateTimeSlot')
                                        : _ctx.$t('forms.addTimeSlot')), 11, _hoisted_48))
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ], 32)
        ])
    ]));
}
